<template>
	<div class="flex-grow" ref="chart" style="width: 100%; height: 700px"></div>
</template>

<script>
import { groupBy, sum, min, max, mean, range } from "lodash";
import * as echarts from "echarts";

export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
		contracts: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			myChart: null,
			// colors: ['#5470C6', '#EE6666']
		};
	},
	methods: {
		text() {
			return `<div> Text</a> <div />`;
		},
	},
	mounted() {
		let chartDom = this.$refs.chart,
			contractDates = this.contracts.map(function (i) {
				return [i["date"], i["price"]];
			}),
			dataX = this.data.map((i) => i.date),
			dataY = this.data.map((i) => i.price),
			option = {
				legend: {},
				tooltip: {
					trigger: "item",
					showContent: true,
					formatter: function (params) {
						return that.text();
					},
				},
				dataset: {
					source: [["product"].concat(dataX), ["Continuous"].concat(dataY)],
				},
				xAxis: {
					type: "time",
					splitLine: {
						show: false,
					},
				},
				yAxis: [
					{ type: "value", name: "Price for futures" },
					{
						type: "value",
						name: "Price for contracts",
						axisLabel: {
							formatter: "{value}",
						},
					},
				],
				grid: {
					top: "15%",
					left: "5%",
					right: "5%",
					bottom: "5%",
					containLabel: true,
				},
				series: [
					{
						type: "line",
						smooth: true,
						seriesLayoutBy: "row",
						//emphasis: { focus: "series" },
						showSymbol: false,
					},
					{
						name: "Price for contracts",
						symbolSize: 10,
						data: contractDates,
						type: "scatter",
						yAxisIndex: 1,
					},
				],
			};

		this.myChart = echarts.init(chartDom);
		this.myChart.setOption(option);
		window.addEventListener("resize", function () {
			that.myChart.resize();
		});

		let that = this;
	},
	computed: {},
};
</script>
